module.exports = __webpack_public_path__ + "img/xs-logo-flat-logo-only.be0c9c3b.png";